import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  selectorInput: {
    '& .MuiAutocomplete-inputRoot': {
      padding: '10px',
    },
  },
  textField: {
    '& .MuiInputBase-root': {
      minHeight: '53px',
    },
  },
});
